Vue.mixin({
  computed: {
    isMobile() {
      // Small devices (landscape phones, less than 768px)
      const isMobile = window.matchMedia(
        "only screen and (max-width: 767.98px)"
      );
      return isMobile.matches ? true : false;
    }
  },
  methods: {
    calculateCompletedPercentage(data) {
      let totalCompleted = data.total_pass + data.total_repair;
      if (totalCompleted === 0 || data.total_quantity === 0) {
        return 0;
      }
      let out = ((totalCompleted / data.total_quantity) * 100).toFixed(0);
      return out > 100 ? 100 : out;
    },
    confirmDelete(name, callback) {
      this.$bvModal
        .msgBoxConfirm(this.$t("confirm_delete_body", { item: name }), {
          title: this.$t("confirm_delete"),
          okVariant: "danger",
          okTitle: this.$t("delete"),
          cancelVariant: "outline-secondary",
          footerClass: "p-2",
          hideHeaderClose: true
        })
        .then(confirmed => {
          if (confirmed) {
            callback();
          }
        });
    }
  }
});
